<template>
  <div>
    <b-row>
      <h5 class="col-sm-12">Filtrar por</h5>

      <b-col sm="2">
        <b-form-group>
          <label class="mb-0" for="txtFechaDesde">Fecha desde</label>
          <b-form-input
            type="date"
            id="txtFechaDesde"
            v-model="range_created_at.startDate"
            :max="
              range_created_at.endDate == ''
                ? maxDate
                : range_created_at.endDate
            "
            @blur="changeDate()"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="2">
        <b-form-group>
          <label class="mb-0" for="txtFechaHasta">Fecha hasta</label>
          <b-form-input
            type="date"
            id="txtFechaHasta"
            v-model="range_created_at.endDate"
            :min="range_created_at.startDate"
            :max="maxDate"
            @blur="changeDate()"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col v-if="role_id == 1 || role_id == 7">
        <b-form-group>
          <label class="mb-0">Responsable</label>
          <b-form-select v-model="staff_id_filter" @change="getData()">
            <template slot="first">
              <option :value="null">-- Todos--</option>
            </template>
            <option v-for="item in lstStaffs" :key="item.id" :value="item.id">
              {{ item.name }} {{ item.last_name }} ({{ item.type_name }})
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <label class="mb-0">Tipo de industria</label>
          <b-form-select v-model="industries_id" @change="getData()">
            <template slot="first">
              <option :value="null">-- Todos --</option>
            </template>
            <option
              v-for="item in lstIndustries"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <label class="mb-0">Avance</label>
          <b-form-select v-model="advance" @change="getData()">
            <template slot="first">
              <option :value="null">-- Todos --</option>
            </template>
            <option v-for="item in lstAdvance" :key="item.id" :value="item.id">
              {{ item.name }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <label class="mb-0">Departamento</label>
          <b-form-select v-model="zone_id" @change="getData()">
            <template slot="first">
              <option :value="null">-- Todos --</option>
            </template>
            <option
              v-for="item in lstDepartamento"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="2">
        <b-form-group>
          <label class="mb-0" for="txtFechaGestionDesde"
            >Fec. entrega cartera desde</label
          >
          <b-form-input
            type="date"
            id="txtFechaGestionDesde"
            v-model="range_task_management.startDate"
            :max="
              range_task_management.endDate == ''
                ? maxDate
                : range_task_management.endDate
            "
            @blur="changeDateTask()"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="2">
        <b-form-group>
          <label class="mb-0" for="txtFechaGestionHasta"
            >Fec. entrega cartera hasta</label
          >
          <b-form-input
            type="date"
            id="txtFechaGestionHasta"
            v-model="range_task_management.endDate"
            :min="range_task_management.startDate"
            :max="maxDate"
            @blur="changeDateTask()"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col sm="3">
        <b-form-group>
          <label class="mb-0">Nombre Cuenta</label>
          <b-form-input
            type="text"
            v-model="customer_filter"
            @blur="getData()"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <div class="card-group mb-3">
      <div class="card card-accent-primary">
        <div class="card-body">
          <div class="text-value">
            $ {{ formatPrice(summary.delivered_capital) }}
          </div>
          <small class="text-muted text-uppercase font-weight-bold"
            >TOTAL ENTREGADO</small
          >
          <hr />
          <div class="text-value">
            $ {{ formatPrice(summary.prejury_capital) }}
          </div>
          <small class="text-muted text-uppercase font-weight-bold"
            >PREJURÍDICO</small
          >
        </div>
      </div>
      <div class="card card-accent-success">
        <div class="card-body">
          <div class="text-value">
            $ {{ formatPrice(summary.jury_capital) }}
          </div>
          <small class="text-muted text-uppercase font-weight-bold"
            >JURÍDICO</small
          >
          <hr />
          <div class="text-value">
            $ {{ formatPrice(summary.extrajury_capital) }}
          </div>
          <small class="text-muted text-uppercase font-weight-bold"
            >EXTRAJURÍDICO</small
          >
        </div>
      </div>

      <div class="card card-accent-warning">
        <div class="card-body">
          <div class="text-value">
            $ {{ formatPrice(summary.collected_capital) }}
          </div>
          <small class="text-muted text-uppercase font-weight-bold"
            >TOTAL COBRADO</small
          >
          <hr />
          <div class="text-value">
            $ {{ formatPrice(summary.receivable_capital) }}
          </div>
          <small class="text-muted text-uppercase font-weight-bold"
            >TOTAL POR COBRAR</small
          >
        </div>
      </div>
    </div>

    <b-row>
      <b-col cols="12" xl="12">
        <transition name="slide">
          <b-card :header="caption">
            <div>
              <b-table
                :hover="hover"
                :striped="striped"
                :bordered="bordered"
                :small="small"
                :fixed="fixed"
                responsive
                :items="items"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                class="text-left"
              >
                <template v-slot:cell(business_name)="data">
                  <!-- <template slot="business_name" slot-scope="data"> -->
                  <div class="text-left">{{ data.item.business_name }}</div>
                </template>

                <template slot="delivered_capital" slot-scope="data">
                  <!-- <template v-slot:cell(delivered_capital)="data"> -->
                  <div class="text-left">
                    ${{ formatPrice(data.item.delivered_capital) }}
                  </div>
                </template>

                <template slot="prejury_capital" slot-scope="data">
                  <!-- <template v-slot:cell(prejury_capital)="data"> -->
                  <div class="text-left">
                    ${{ formatPrice(data.item.prejury_capital) }}
                  </div>
                </template>

                <template slot="jury_capital" slot-scope="data">
                  <!-- <template v-slot:cell(jury_capital)="data"> -->
                  <div class="text-left">
                    ${{ formatPrice(data.item.jury_capital) }}
                  </div>
                </template>

                <template slot="extrajury_capital" slot-scope="data">
                  <!-- <template v-slot:cell(extrajury_capital)="data"> -->
                  <div class="text-left">
                    ${{ formatPrice(data.item.extrajury_capital) }}
                  </div>
                </template>

                <template slot="collected_capital" slot-scope="data">
                  <!-- <template v-slot:cell(collected_capital)="data"> -->
                  <div class="text-left">
                    ${{ formatPrice(data.item.collected_capital) }}
                  </div>
                </template>

                <template slot="receivable_capital" slot-scope="data">
                  <!-- <template v-slot:cell(receivable_capital)="data"> -->
                  <div class="text-left">
                    ${{ formatPrice(data.item.receivable_capital) }}
                  </div>
                </template>

                <template slot="options" slot-scope="data">
                  <!-- <template v-slot:cell(options)="data"> -->
                  <b-button
                    size="sm"
                    variant="primary"
                    class="mr-1 btn-custom-size"
                    @click="viewCustomer(data.item.id)"
                    title="Gestionar"
                  >
                    <i class="fa fa-eye"></i>
                  </b-button>
                </template>
              </b-table>
            </div>
            <hr />

            <div class="row">
              <div class="col-sm-4">
                Mostrando
                {{
                  getRowCount(items) > perPage * currentPage
                    ? perPage * currentPage
                    : getRowCount(items)
                }}
                de {{ getRowCount(items) }} registros
              </div>
              <div class="col-sm-8">
                <nav>
                  <b-pagination
                    size="sm"
                    align="right"
                    :total-rows="getRowCount(items)"
                    :per-page="perPage"
                    v-model="currentPage"
                    prev-text="Anterior"
                    next-text="Siguiente"
                    :limit="10"
                  />
                </nav>
              </div>
            </div>
          </b-card>
        </transition>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "CurrentWalletStatus",
  props: {
    caption: {
      type: String,
      default: "ESTADO ACTUAL DE LA CARTERA",
    },
    hover: {
      type: Boolean,
      default: true,
    },
    striped: {
      type: Boolean,
      default: true,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: true,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      auth: localStorage.getItem("auth"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      role_id: localStorage.getItem("role_id"), // PARA DETERMINAR EL ROL DEL USUARIO QUE INGRESA
      isCustomer: false,
      fields: [
        { key: "status_name", label: "Estado", sortable: true },
        { key: "business_name", label: "Cuenta", sortable: true },

        { key: "delivered_capital", label: "Total entregado", sortable: true },
        { key: "prejury_capital", label: "Prejurídico", sortable: true },
        { key: "jury_capital", label: "Jurídico", sortable: true },
        { key: "extrajury_capital", label: "Extrajurídico", sortable: true },
        { key: "collected_capital", label: "Cobrado", sortable: true },
        { key: "receivable_capital", label: "Por cobrar", sortable: true },

        { key: "options", label: "Opciones", sortable: false },
      ],
      status: null,
      items: [],
      pagination: {},
      filter: null,
      tableData: [],
      tableHeader: [],
      errores: [],
      mostrarResumen: false,
      rowCount: -1,
      //
      selectItems: [],
      selectAll: false,
      // FILTROS DE BUSQUEDA
      maxDate: moment(String(new Date())).format("YYYY-MM-DD"),
      range_created_at: {
        // startDate: moment(String(sumarDias(new Date(), -30))).format(
        //   "YYYY-MM-DD"
        // ),
        startDate: moment(String(new Date("2012", "12", "01"))).format(
          "YYYY-MM-DD"
        ),
        endDate: moment(String(new Date())).format("YYYY-MM-DD"),
      },
      range_task_management: {
        startDate: null,
        endDate: null,
      },
      staff_id_filter: null,
      industries_id: null,
      advance: null,
      zone_id: null,
      customer_filter: null,
      summary_month: {
        january: 0,
        february: 0,
        march: 0,
        april: 0,
        may: 0,
        june: 0,
        july: 0,
        august: 0,
        september: 0,
        october: 0,
        november: 0,
        december: 0,
      },

      summary: {
        delivered_capital: 0,
        prejury_capital: 0,
        jury_capital: 0,
        extrajury_capital: 0,
        collected_capital: 0,
        receivable_capital: 0,
      },

      // LISTAS PARA LOS FILTROS
      lstAdvance: [],
      lstIndustries: [],
      lstStaffs: [],
      lstDepartamento: [],

      // PAGINACIÓN DE VUE
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
    };
  },
  mounted() {
    this.initParameters();
    this.getData();
  },
  computed: {},
  methods: {
    initParameters() {
      var auth = JSON.parse(localStorage.getItem("auth"));
      this.isCustomer = auth[0].customer_id != null ? true : false;
      this.staff_id_filter = this.role_id == 1 || this.role_id == 7 ? null : auth[0].staff_id;

      // 4: AVANCE DE LA CUENTA
      this.$http.get(`${this.$urlApi}parameters/4?token=${this.token}`).then(
        (response) => {
          this.lstAdvance = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

      // INSDUSTRIAS
      this.$http.get(`${this.$urlApi}industries?token=${this.token}`).then(
        (response) => {
          this.lstIndustries = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

      //LISTADO DE STAFF'S: 42: COMERCIAL
      this.$http.get(`${this.$urlApi}staffs/type/42?token=${this.token}`).then(
        (response) => {
          this.lstStaffs = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

      //DEPARTAMENTOS DE COLOMBIA
      this.$http.get(`${this.$urlApi}zones/1?token=${this.token}`).then(
        (response) => {
          this.lstDepartamento = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );
    },
    changeDate() {
      if (
        this.range_created_at.startDate != "" &&
        this.range_created_at.endDate != ""
      ) {
        this.getData();
      } else return;
    },
    changeDateTask() {
      if (
        this.range_task_management.startDate != "" &&
        this.range_task_management.startDate != null &&
        this.range_task_management.endDate != "" &&
        this.range_task_management.endDate != null
      ) {
        this.getData();
      } else return;
    },
    getData: function (urlPage) {
      let authAux = JSON.parse(this.auth);
      authAux[0].staff_id_filter = this.staff_id_filter;
      authAux[0].industries_id = this.industries_id;
      authAux[0].advance = this.advance;
      authAux[0].zone_id = this.zone_id;
      authAux[0].customer_name = this.customer_filter;
      authAux[0].image = "";

      authAux[0].start_date = moment(this.range_created_at.startDate).format(
        "YYYY-MM-DD"
      );
      authAux[0].end_date = moment(this.range_created_at.endDate).format(
        "YYYY-MM-DD"
      );

      if (
        this.range_task_management.startDate != "" &&
        this.range_task_management.startDate != null &&
        this.range_task_management.endDate != "" &&
        this.range_task_management.endDate != null
      ) {
        authAux[0].start_date_task_management = moment(
          this.range_task_management.startDate
        ).format("YYYY-MM-DD");
        authAux[0].end_date_task_management = moment(
          this.range_task_management.endDate
        ).format("YYYY-MM-DD");
      }

      let url = `${this.$urlApi}customers/indicators/currentwalletstatus?token=${this.token}`;
      showLoader();
      this.$http
        .post(url, JSON.stringify(authAux), {
          headers: { "Content-Type": "application/json" },
        })
        .then(
          function (response) {
            console.log(response);
            this.items = response.data.data;
            this.summary = response.data.summary;
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    formatDateDescription(value) {
      if (!value) return "";
      else {
        if (value == "--") return value;
        else {
          var d = moment(value).format("DD");
          var m = moment(value).format("MMM");
          var a = moment(value).format("YYYY");
          return d + " de " + m + " " + a;
        }
      }
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    getRowCount(items) {
      return items.length;
    },
    viewCustomer(id) {
      let url = `${location.origin}/#/customers/view/${id.toString()}`;
      window.open(url, "_blank");
    },
  },
};
</script>
